import type { ReactNode } from "react"
import { BottomSheet } from "../BottomSheet/BottomSheet"

export type AskAISheetMode = "hidden" | "sheet" | "expanded"

export interface AskAISheetProps {
  mode: AskAISheetMode
  onExpand?: () => void
  onCollapse?: () => void
  onClose?: () => void
  chatPanelSlot: ReactNode
  closeOnEscape?: boolean
  dragThresholdPx?: number
  className?: string
}

export function AskAISheet({
  mode,
  onExpand,
  onCollapse,
  onClose,
  chatPanelSlot,
  closeOnEscape = true,
  dragThresholdPx,
  className,
}: AskAISheetProps) {
  const open = mode === "sheet" || mode === "expanded"
  const isExpanded = mode === "expanded"

  return (
    <BottomSheet
      open={open}
      onClose={() => onClose?.()}
      expanded={isExpanded}
      onExpandedChange={(next) => {
        if (next) onExpand?.()
        else onCollapse?.()
      }}
      ariaLabel="Chat"
      closeOnEscape={closeOnEscape}
      dragThresholdPx={dragThresholdPx}
      className={className}
    >
      {chatPanelSlot}
    </BottomSheet>
  )
}
